import React, { createElement } from 'react';

import { FEATURE_FLAGS } from '~common';
import { checkEnabledFeatureFlag } from '~utils';

type Props<P> = {
  ffKey: FEATURE_FLAGS;
  component?: React.FC<P>;
  fallbackComponent?: React.FC<P>;
  children?: React.ReactNode;
  fallBackChildren?: React.ReactNode;
};

export const FeatureFlagsRenderer = <P extends object>({
  ffKey,
  children = null,
  component,
  fallbackComponent,
  fallBackChildren = null,
}: Props<P>) => {
  if (checkEnabledFeatureFlag(ffKey.toString())) {
    return <>{createElement(component ?? React.Fragment, null, children)}</>;
  }

  return (
    <>
      {createElement(
        fallbackComponent ?? React.Fragment,
        null,
        fallBackChildren ?? children,
      )}
    </>
  );
};
